export enum IconTypeEnum {
  facebookWhite = "facebookWhite",
  telegramWhite = "telegramWhite",
  emailWhite = "emailWhite",
  linkedinWhite = "linkedinWhite",
  twitterWhite = "twitterWhite",
  whatsappWhite = "whatsappWhite",
  facebook = "facebook",
  telegram = "telegram",
  email = "email",
  linkedin = "linkedin",
  twitter = "twitter",
  whatsapp = "whatsapp",
  instagram = "instagram",
  profile = "profile",
  search = "search",
  hamburgerForDesktop = "hamburgerForDesktop",
  hamburgerForMobile = "hamburgerForMobile",
  gift = "gift",
  closeWhite = "closeWhite",
  share = "share",
  link = "link",
  pulse = "pulse",
  close = "close",
  xMark = "xMark",
  chrevonRightArrow = "chrevonRightArrow",
  chrevonLeftDarkArrow = "chrevonLeftDarkArrow",
  chrevonRightLightArrow = "chrevonLeftLightArrow",
  play = "play",
  playLine = "playLine",
  shareLine = "shareLine",
  shareLineWhite = "shareLineWhite",
  bookmark = "bookmark",
  more = "more",
  print = "print",
  preferences = "preferences",
  follow = "follow",
  unfollow = "unfollow",
  feedback = "feedback",
  reuse = "reuse",
  emailV3 = "emailV3",
}

export type IconProps = React.SVGProps<SVGSVGElement> & {
  /** The type of icon to render. */
  type: IconTypeEnum;
  /** The size of the icon in pixels. Defaults to 24. */
  size?: number;
  /** Additional CSS class for styling the icon. */
  className?: string;
};
